import React from "react";
import { useNavigate } from "react-router-dom";
import { useApp } from "@/context/AppContext";
import { Brand, LangSwitcher } from "@/components/Brand";
import { Button } from "@/components/ui/button";
import { ArrowLeft, LogOut } from "lucide-react";

export function TopBar({ showBack, backTo = -1, showLogout }) {
  const { t, logout } = useApp();
  const nav = useNavigate();
  return (
    <header className="sticky top-0 z-30 border-b border-border bg-background/80 backdrop-blur-xl">
      <div className="mx-auto flex max-w-5xl items-center justify-between gap-4 px-4 py-3 sm:px-6">
        <div className="flex items-center gap-3">
          {showBack && (
            <Button
              data-testid="back-button"
              variant="ghost"
              size="icon"
              className="rounded-full"
              onClick={() => nav(backTo)}
            >
              <ArrowLeft className="h-5 w-5" strokeWidth={1.5} />
            </Button>
          )}
          <button onClick={() => nav("/")} className="cursor-pointer">
            <Brand small />
          </button>
        </div>
        <div className="flex items-center gap-2">
          <LangSwitcher />
          {showLogout && (
            <Button
              data-testid="logout-button"
              variant="outline"
              className="rounded-full"
              onClick={() => {
                logout();
                nav("/");
              }}
            >
              <LogOut className="mr-2 h-4 w-4" strokeWidth={1.5} />
              {t("logout")}
            </Button>
          )}
        </div>
      </div>
    </header>
  );
}
